import { Routes, Route } from 'react-router-dom'
import { useEffect } from 'react'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'

// Layout Components
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import ScrollToTop from './components/ScrollToTop'
import PageTransition from './components/PageTransition'
import CustomCursor from './components/CustomCursor'
import FloatingElements from './components/FloatingElements'

// Pages
import Home from './pages/Home'
import About from './pages/About'
import Philosophy from './pages/Philosophy'
import Team from './pages/Team'
// import Menu from './pages/Menu'
import Franchise from './pages/Franchise'
import Stores from './pages/Stores'
import Careers from './pages/Careers'
import Contact from './pages/Contact'
import NotFound from './pages/NotFound'

// Register GSAP plugins
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)

function App() {
  useEffect(() => {
    // Set up smooth scrolling behavior
    ScrollTrigger.defaults({
      toggleActions: 'play none none reverse'
    })
    
    return () => {
      ScrollTrigger.killAll()
    }
  }, [])

  return (
    <div className="app">
      <FloatingElements />
      <CustomCursor />
      <Navbar />
      <ScrollToTop />
      <PageTransition />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/philosophy" element={<Philosophy />} />
          <Route path="/team" element={<Team />} />
          {/* <Route path="/menu" element={<Menu />} /> */}
          <Route path="/franchise" element={<Franchise />} />
          <Route path="/stores" element={<Stores />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  )
}

export default App
